/**
 * Loads PLP facet scripts on filter interaction (avoids TBT during initial load).
 */
(function () {
  const urls = window.sbIdleScriptUrls || [];
  if (!urls.length) return;

  let loaded = false;

  const load = () => {
    if (loaded) return;
    loaded = true;
    urls.forEach((src) => {
      if (document.querySelector(`script[src="${src}"]`)) return;
      const script = document.createElement('script');
      script.src = src;
      script.defer = true;
      document.head.appendChild(script);
    });
    cleanup();
  };

  const cleanup = () => {
    document.removeEventListener('click', onInteraction, true);
    document.removeEventListener('keydown', onInteraction, true);
  };

  const onInteraction = (event) => {
    const target = event.target;
    if (
      target.closest(
        '.mobile-facets__open, .mobile-facets__wrapper, .facets__form, .facet-filters, [data-sb-plp-drawer-filters], .sb-plp-filter-trigger'
      )
    ) {
      load();
    }
  };

  document.addEventListener('click', onInteraction, true);
  document.addEventListener('keydown', onInteraction, true);

  const params = new URLSearchParams(window.location.search);
  const hasClientFilter = ['filter.p.m.snoozebaby.size', 'filter.p.m.snoozebaby.color', 'filter.p.m.snoozebaby.tog'].some(
    (key) => params.has(key)
  );
  if (hasClientFilter) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', load);
    else load();
  }
})();
